import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Transformation() {
  const changes = ['Dejas de sentir que todo depende de tu "aguante".', 'Empiezas a hablar con más claridad y menos explosión.', 'Te das permiso de descansar sin justificarte tanto.', 'Tomas decisiones con menos culpa y más calma.', 'Recuperas pedacitos de identidad (que hoy están en pausa).'];
  return <section className="py-10 px-4 bg-sage/10" data-id="element-444">
      <div className="max-w-3xl mx-auto" data-id="element-445">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-446">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-2" data-id="element-447">
            Qué cambia cuando aplicas el Mapa
          </h2>
          <p className="text-navy/60 italic" data-id="element-448">
            (Sin promesas mágicas, solo cambios reales)
          </p>
        </motion.div>

        <div className="space-y-3" data-id="element-449">
          {changes.map((change, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 p-3 bg-white rounded-lg shadow-sm" data-id="element-450">
              <div className="bg-sage/20 p-1 rounded-full shrink-0 mt-1" data-id="element-451">
                <Check className="w-4 h-4 text-sage" data-id="element-452" />
              </div>
              <p className="text-navy font-medium text-lg" data-id="element-453">{change}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}